import React, { useState } from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import Slider from '@react-native-community/slider';
import { Paragraph, Dialog, Portal } from 'react-native-paper';
import { FontAwesome5 } from '@expo/vector-icons';
import AppText from './AppText';
import { pixelDimensions } from '../../config/utils';
import { appColors } from '../../assets/styles/global';

const AppSlider = ({
  title,
  value,
  changeValue,
  min,
  max,
  step,
  sliderContainerStyles,
  sliderSubContainerStyles,
  showValue = true,
  showHelper = false,
  textHelper = '',
}) => {
  const [showDialog, setShowDialog] = useState(false);

  return (
    <View style={[styles.viewSliderContainer, sliderContainerStyles]}>
      <Portal>
        <Dialog visible={showDialog} onDismiss={() => setShowDialog(false)}>
          <Dialog.Content>
            <Paragraph>{textHelper}</Paragraph>
          </Dialog.Content>
        </Dialog>
      </Portal>
      <View style={{ flexDirection: 'row' }}>
        <AppText style={styles.textSlider}>{title}</AppText>
        {showHelper && (
        <TouchableOpacity onPress={() => setShowDialog(true)}>
          <FontAwesome5 name="question-circle" size={pixelDimensions(4)} />
        </TouchableOpacity>
        )}
      </View>
      <View style={[styles.viewSlider, sliderSubContainerStyles]}>
        <Slider
          thumbTintColor={appColors.primary}
          style={styles.slider}
          minimumValue={min || 0}
          maximumValue={max || 100}
          step={step || 10}
          onValueChange={(val) => changeValue(title, val)}
        />
        {showValue && <AppText style={styles.textSlider}>{value}</AppText>}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  slider: {
    paddingRight: pixelDimensions(2),
    flex: 1,
  },
  textSlider: {
    fontSize: pixelDimensions(4),
    marginRight: pixelDimensions(2),
  },
  viewSlider: {
    flexDirection: 'row',
    width: pixelDimensions(40),
  },
  viewSliderContainer: {
    paddingVertical: pixelDimensions(2),
    paddingHorizontal: pixelDimensions(5),
  },
});

export default AppSlider;
